import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../store/types';
import { PaymentMethod } from '../../../services/exports/Constants';

/**
 * The methods a gift-card purchase cannot be paid with: cash never, and whatever the backend names
 * as unavailable for gift cards — a method the restaurant's gateway takes on delivery orders alone
 * (Klarna through PPRO needs a billing address, and a gift card has none).
 */
export default function useGiftCardExcludedPaymentMethods(): PaymentMethod[] {
  const { company } = useSelector((state: StoreInterface) => state.initialData);
  const unavailable = company?.gift_card_unavailable_payment_methods;

  return useMemo(() => [PaymentMethod.Cash, ...(unavailable ?? [])], [unavailable]);
}
